import { CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST } from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressCheckboxGroupsOptionalIdsState = string[];

const initialState: ContractProgressCheckboxGroupsOptionalIdsState = [];

export default function reducer(
  state: ContractProgressCheckboxGroupsOptionalIdsState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return initialState;
    default:
      return state;
  }
}
